export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#2C2C2C] rounded-t-2xl">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="text-2xl font-bold text-white mb-3">Claim It Assist</div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Your advocate for fair insurance settlements. We work for you, not the insurance company.
            </p>
            <div className="flex space-x-3">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-[#FF6B35] transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-white text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-[#FF6B35] transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-white text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-[#FF6B35] transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-white text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4 text-sm">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('claims')} className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  Claims We Handle
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('process')} className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  Our Process
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('careers')} className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  Careers
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4 text-sm">Service Areas</h3>
            <ul className="space-y-2">
              <li className="text-gray-400 text-sm">New Jersey</li>
              <li className="text-gray-400 text-sm">Pennsylvania</li>
              <li className="text-gray-400 text-sm">Maryland</li>
              <li className="text-gray-400 text-sm">All Surrounding Areas</li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4 text-sm">Contact Info</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <i className="ri-phone-line text-[#FF6B35] text-lg mt-0.5"></i>
                <a href="tel:+19089222919" className="text-gray-400 hover:text-white transition-colors text-sm">
                  (908) 922-2919
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-mail-line text-[#FF6B35] text-lg mt-0.5"></i>
                <a href="mailto:info@claimitassist.com" className="text-gray-400 hover:text-white transition-colors text-sm">
                  info@claimitassist.com
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-[#FF6B35] text-lg mt-0.5"></i>
                <span className="text-gray-400 text-sm">
                  Serving NJ, PA & MD
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © 2025 Claim It Assist. All rights reserved.
            </div>
            <div className="text-gray-400 text-sm">
              Michael Robbins Licensed Public Adjuster | NJ #91415 | PA #1153518 | MD #3002638238
            </div>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}